import YuxelServicesMaster from "../components/YuxelServicesMaster";
export default function ServicesIndex() { return <YuxelServicesMaster />; }
